// TODO: replace with types from @taxora-api once backend is implemented and API regenerated

export type DocumentStatus = 'TO_PROCESS' | 'NEEDS_CLARIFICATION' | 'PROCESSED' | 'DUPLICATE';

export type MissingDocumentRequestStatus =
  | 'PENDING'
  | 'SUBMITTED'
  | 'UNDER_REVIEW'
  | 'RESOLVED'
  | 'CANCELLED';

export type DocumentType =
  | 'SALES_INVOICE'
  | 'SALES_RECEIPT'
  | 'PURCHASE_INVOICE'
  | 'PURCHASE_AUTO_INVOICE'
  | 'PURCHASE_RECEIPT'
  | 'RECEIPT_NO_CUI'
  | 'FUEL_RECEIPT'
  | 'AUTO_EXPENSE_RECEIPT'
  | 'OTHER';

export type DocumentEventType =
  | 'UPLOADED'
  | 'STATUS_CHANGED'
  | 'CLARIFICATION_REQUESTED'
  | 'CLARIFICATION_ANSWERED'
  | 'DELETED';

export interface DocumentUserDto {
  id: number;
  firstName: string;
  lastName: string;
}

export interface DocumentStorageFileDto {
  id: number;
  key: string;
  originalName: string;
  mimeType: string;
  size: number;
}

export interface DocumentEventResponseDto {
  id: number;
  type: DocumentEventType;
  oldStatus?: DocumentStatus;
  newStatus?: DocumentStatus;
  reason?: string;
  createdAt: string;
  user: DocumentUserDto;
}

export interface DocumentClarificationResponseDto {
  id: number;
  message: string;
  isFromAccountant: boolean;
  createdAt: string;
  user: DocumentUserDto;
}

export interface DocumentResponseDto {
  id: number;
  type: DocumentType;
  status: DocumentStatus;
  reference?: string | null;
  value?: number | null;
  currency?: string;
  documentDate?: string | null;
  supplierName?: string | null;
  clientName?: string | null;
  supplierCui?: number | null;
  businessNote?: string | null;
  deletedAt?: string | null;
  deleteReason?: string | null;
  createdAt: string;
  updatedAt: string;
  uploadedBy?: DocumentUserDto | null;
  deletedBy?: DocumentUserDto | null;
  storageFile: DocumentStorageFileDto;
  events: DocumentEventResponseDto[];
  clarifications: DocumentClarificationResponseDto[];
}

export interface DocumentMonthSummaryDto {
  year?: number | null;
  month?: number | null;
  count: number;
  filteredCount?: number;
  needsClarificationCount?: number;
  label: string;
  totalAmount?: number;
  currency?: string;
}

export interface DocumentsListResponseDto {
  data: DocumentResponseDto[];
  total: number;
  page: number;
  limit: number;
}

export interface MissingDocumentRequestDto {
  id: number;
  title: string;
  type: DocumentType;
  year: number | null;
  month: number | null;
  status: MissingDocumentRequestStatus;
  requestedBy: DocumentUserDto;
  createdAt: string;
  description?: string;
}

export const DOCUMENT_STATUS_LABELS: Record<DocumentStatus, string> = {
  TO_PROCESS: 'De procesat',
  NEEDS_CLARIFICATION: 'Necesita clarificare',
  PROCESSED: 'Procesate',
  DUPLICATE: 'Duplicate',
};

export const DOCUMENT_STATUS_LABEL_KEYS: Record<DocumentStatus, string> = {
  TO_PROCESS: 'common.documents.status.toProcess',
  NEEDS_CLARIFICATION: 'common.documents.status.needsClarification',
  PROCESSED: 'common.documents.status.processed',
  DUPLICATE: 'common.documents.status.duplicate',
};

export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  SALES_INVOICE: 'Factura de vanzare',
  SALES_RECEIPT: 'Bon fiscal de vanzare',
  PURCHASE_INVOICE: 'Factura de achizitie',
  PURCHASE_AUTO_INVOICE: 'Factura de achizitie auto',
  PURCHASE_RECEIPT: 'Bon fiscal de achizitie',
  RECEIPT_NO_CUI: 'Bon fiscal fara CUI',
  FUEL_RECEIPT: 'Bon combustibil',
  AUTO_EXPENSE_RECEIPT: 'Bon cheltuieli auto',
  OTHER: 'Altele',
};

export const DOCUMENT_TYPE_LABEL_KEYS: Record<DocumentType, string> = {
  SALES_INVOICE: 'common.documents.type.salesInvoice',
  SALES_RECEIPT: 'common.documents.type.salesReceipt',
  PURCHASE_INVOICE: 'common.documents.type.purchaseInvoice',
  PURCHASE_AUTO_INVOICE: 'common.documents.type.purchaseAutoInvoice',
  PURCHASE_RECEIPT: 'common.documents.type.purchaseReceipt',
  RECEIPT_NO_CUI: 'common.documents.type.receiptNoCui',
  FUEL_RECEIPT: 'common.documents.type.fuelReceipt',
  AUTO_EXPENSE_RECEIPT: 'common.documents.type.autoExpenseReceipt',
  OTHER: 'common.documents.type.other',
};

export const DOCUMENT_STATUS_SEVERITY: Record<
  DocumentStatus,
  'info' | 'warn' | 'success' | 'secondary'
> = {
  TO_PROCESS: 'info',
  NEEDS_CLARIFICATION: 'warn',
  PROCESSED: 'success',
  DUPLICATE: 'secondary',
};

export const MISSING_DOCUMENT_REQUEST_STATUS_LABELS: Record<MissingDocumentRequestStatus, string> =
  {
    PENDING: 'In asteptare',
    SUBMITTED: 'Trimise',
    UNDER_REVIEW: 'In verificare',
    RESOLVED: 'Rezolvata',
    CANCELLED: 'Anulata',
  };

export const MISSING_DOCUMENT_REQUEST_STATUS_LABEL_KEYS: Record<
  MissingDocumentRequestStatus,
  string
> = {
  PENDING: 'common.documents.missingRequestStatus.pending',
  SUBMITTED: 'common.documents.missingRequestStatus.submitted',
  UNDER_REVIEW: 'common.documents.missingRequestStatus.underReview',
  RESOLVED: 'common.documents.missingRequestStatus.resolved',
  CANCELLED: 'common.documents.missingRequestStatus.cancelled',
};

export interface DocumentFilterParams {
  search?: string;
  status?: DocumentStatus;
  type?: DocumentType;
  year?: number;
  month?: number;
  documentDateFrom?: string;
  documentDateTo?: string;
  referenceSearch?: string;
  valueMin?: number;
  valueMax?: number;
  page?: number;
  limit?: number;
}
